import React, { Component } from "react";
import { Row, Col, Calendar, Button, Modal, Input, Icon, Divider } from "antd";
import moment from "moment";
import _ from "underscore";
import { app } from "../../app";
import api from "../../api";
import DutyAdd from "./DutyAdd";
import Dutyexamine from "./Dutyexamine";

import sign_rl_icon from "../../assets/sign_rl_icon.png";
import help from "../../assets/help.png";
import Rule from "../../components/Rule";
import { name } from "file-loader";
import { div } from "echarts-gl";

class UserSign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signData: [],
      recordData: [],
      currentTime: moment(),
      selectDate: moment(),
      continuity: 0,
      aggregatescore: 0,
      date: "",
      detail_visible: false,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.handleSignData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 获取值日数据
   * @returns {Promise<void>}
   */
  handleSignData = async (date) => {
    await app.alert("正在加载~", "loading");
    let params = {
      version_id: api.version_id,
      date: moment(time).format("YYYY-MM"),
      account: app.getData("account"),
    };
    if (date) params.date = date.format("YYYY-MM");

    let { flag, data, msg, time } = await app.post(api.dutyList, params);
    if (flag !== 1) {
      app.alert(msg, "warn");
      data = [];
    }
    await this.setData({
      signData: data,
      currentTime: moment(time),
      selectDate: date || moment(time),
      dates:date
    });
    app.alertDestroy();
  };

  OpenAddPlayerModal = (e) => {
    this.setData({ add_modal: true, date: e });
  };
  OpenAddPlayerModal2 = (e, i) => {
    let { date } = this.state;
    date = e;
    this.setData({ add_modal2: true, date, list: i });
  };
  CloseAddPlayerModal = async (flag) => {
    await this.setData({ add_modal: false, add_flush: true });
    await this.setData({ add_flush: false, date: undefined });
    if (flag) {
      let { dates } = this.state;
      this.handleSignData(dates);
    }
  };
  CloseAddPlayerModal2 = async (flag) => {
    await this.setData({ add_modal2: false, add_flush: true });
    await this.setData({ add_flush: false, date: undefined });
    if (flag == true) {
      let { dates } = this.state;
      this.handleSignData(dates);
    } else if (this.isDate(flag)) {
      await this.setData({ add_modal: true, date: flag });
    }
  };
  isDate = (str) => {
    const date = new Date(str);

    return !isNaN(date);
  };
  /**
   * 日期单元格样式
   * @param date
   * @returns {*}
   */
  handleFullDateRender = (date) => {
    let { signData, currentTime, selectDate } = this.state,
      days = date.daysInMonth(),
      dateStr = date.format("YYYY-MM-DD"),
      dayStr = date.format("DD");
    if (!selectDate.isSame(date, "month")) {
      return "";
    } else {
      //   let data = _.find(
      //     signData,
      //     (d) => dateStr === moment(d.duty_date).format("YYYY-MM-DD")
      //   );
      let data = [];
      signData.map((item, index) => {
        if (dateStr === moment(item.duty_date).format("YYYY-MM-DD")) {
          data.push(item);
        }
      });
      if (data.length > 0) {
        return (
          <div
            className="sic-item sici-yes"
            style={{ cursor: "pointer",width:'95%',margin:5 }}
            onClick={() => this.OpenAddPlayerModal2(dateStr, data)}
          >
            <div className="sid-day">{dayStr}</div>
            <div style={{ display: "flex" }}>
              {data.map((item, index) => {
                return <p style={{ margin: "0 5px" }}>{item.vname}</p>;
              })}
            </div>
          </div>
        );
      } else if (date.isBefore(moment(currentTime).add(1, "d"), "day")) {
        return (
          <div
            className="sic-item sici-no"
            style={{ cursor: "pointer",width:'95%',margin:5 }}
            onClick={() => this.OpenAddPlayerModal(dateStr)}
          >
            <div className="sid-day">{dayStr}</div>
            <div className="sid-text">未设置</div>
          </div>
        );
      } else {
        return (
          <div
            className="sic-item sici-no"
            style={{ cursor: "pointer",width:'95%',margin:5 }}
            onClick={() => this.OpenAddPlayerModal(dateStr)}
          >
            <div className="sid-day">{dayStr}</div>
            <div className="sid-text">未设置</div>
          </div>
        );
      }
    }
  };

  render() {
    let {
      currentTime,
      continuity,
      aggregatescore,
      recordData,
      sign_loading,
      qingjia_loading,
      detail_loading,
      detail_data,
      detail_visible,
      add_modal,
      add_flush,
      add_modal2,
      date,
      list,
    } = this.state;
    return (
      <div className="sign-index">
        <div className="si-title">值日设置</div>
        <div className="si-content">
          <Calendar
            // validRange={[moment("2018-01-01"), currentTime]}
            className="custom-calendar"
            defaultValue={currentTime}
            dateFullCellRender={this.handleFullDateRender}
            onPanelChange={this.handleSignData}
          />
        </div>
        <Modal
          visible={add_modal}
          title={
            <div style={{ position: "relative",display:'flex' }}>
              <p>设置值日</p>
              <p style={{color:'red',marginLeft:20}}>每日可设置2名值日人员</p>
              <p style={{ position: "absolute",top:0,left:'45%' }}>{date}</p>
            </div>
          }
          onCancel={this.CloseAddPlayerModal}
          footer={null}
          width={1200}
          maskClosable={false}
          destroyOnClose={true}
          className="edit-team-modal"
        >
          <DutyAdd
            flush={add_flush}
            date={date}
            onClose={this.CloseAddPlayerModal}
          />
        </Modal>
        <Modal
          visible={add_modal2}
          title={
            <div style={{ position: "relative",display:'flex' }}>
              <p>值日人员</p>
              <p style={{color:'red',marginLeft:20}}>每日可设置2名值日人员</p>
              <p style={{ position: "absolute",top:0,left:'45%' }}>{date}</p>
            </div>
          }
          onCancel={this.CloseAddPlayerModal2}
          footer={null}
          width={1200}
          maskClosable={false}
          destroyOnClose={true}
          className="edit-team-modal"
        >
          <Dutyexamine
            list={list}
            date={date}
            onClose={this.CloseAddPlayerModal2}
          />
        </Modal>
      </div>
    );
  }
}

export default UserSign;



// WEBPACK FOOTER //
// ./src/routes/grade/duty.jsx